import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { VehicleAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    deleteVehicle: PropTypes.func,
    getVehicles: PropTypes.func,
    location: PropTypes.object,
    permissions: PropTypes.arrayOf(PropTypes.string),
    vehicles: PropTypes.object,
  };

  componentDidMount() {
    this.props.getVehicles(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteVehicle(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getVehicles({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      getVehicles,
      location = {},
      permissions = [],
      vehicles: { data: vehicles = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Vehicle</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getVehicles}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('vehicle.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0 table-responsive">
              {vehicles?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {vehicles?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        ['vehicle.delete', 'vehicle.edit']?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '175px' }}
                        >
                          Action
                        </th>
                      )}
                      {!authHasOffice && <th>Office</th>}
                      <th>Model/Make of Vehicle</th>
                      <th>Class of Vehicle</th>
                      <th>Number of Cylinder with CC</th>
                      <th>Size of Tyre</th>
                      <th>Year of Manufacture/Assemble</th>
                      <th>Horse Power</th>
                      <th>Laden Weight</th>
                      <th>Wheel Base</th>
                      <th>Seating Capacity</th>
                      <th>Maker's Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicles?.map?.(row => (
                      <tr key={row.id}>
                        {permissions?.some?.(p =>
                          ['vehicle.delete', 'vehicle.edit']?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('vehicle.edit') && (
                                <Link
                                  className="btn btn-info btn-sm"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('vehicle.delete') && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.model}</td>
                        <td>{row.class}</td>
                        <td>{row.cylinder_cc}</td>
                        <td>{row.tyre_size}</td>
                        <td>{row.manufacture_year}</td>
                        <td>{row.horse_power}</td>
                        <td>{row.laden_weight}</td>
                        <td>{row.wheel_base}</td>
                        <td>{row.seating_capacity}</td>
                        <td>{row.maker_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  permissions: state?.auth?.permissions,
  vehicles: state?.vehicle?.list,
});

const mapDispatchToProps = dispatch => ({
  deleteVehicle: id => dispatch(VehicleAction.deleteVehicle(id)),
  getVehicles: params => dispatch(VehicleAction.getVehicles(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
